import {
    Alert, Box, Container, ContentLayout, Header, Spinner
} from '@amzn/awsui-components-react';
import React, { useEffect, useRef } from 'react';
import { DashboardExperience } from 'amazon-quicksight-embedding-sdk';
import { renderDashboardEmbedUrl } from './helpers';
import { useLazyGetQuickSightDashboardUrlQuery } from 'src/store/apis/quickSightApi';
import { STAGE } from 'src/constants';
import { QuickSightDashBoardProps } from './interfaces';

export default function QuickSightDashBoard({ header, description, dashboardIds, region }: QuickSightDashBoardProps) {
    const DASHBOARD_CONTAINER_ID = "dashboard-experience-container";
    const [getQuicksightDashboard, { isFetching, isError }] = useLazyGetQuickSightDashboardUrlQuery();
    const dashboardRef = useRef<DashboardExperience | null>(null);

    const dashboardId = dashboardIds[STAGE as keyof typeof dashboardIds];
    
    useEffect(() => {
        if (!dashboardId) return;

        const fetchDashboard = async () => {
            try {
                const response = await getQuicksightDashboard({ dashboardId, region }, false).unwrap();
                const dashboard = await renderDashboardEmbedUrl(response.url, DASHBOARD_CONTAINER_ID);
                dashboardRef.current = dashboard;
            } catch (error) {
                console.error('Error fetching QuickSight dashboard:', error);
            }
        };

        fetchDashboard();

        return () => {
            if (dashboardRef.current) {
                dashboardRef.current = null;
            }
        };
    }, [dashboardId, region, getQuicksightDashboard]);

    if (!dashboardId) {
        return (
            <ContentLayout header={<Header variant="h1" description={description}>{header}</Header>}>
                <Container>
                    <Alert type="info">No dashboard available for the current stage.</Alert>
                </Container>
            </ContentLayout>
        );
    }

    return (
        <ContentLayout header={<Header variant="h1" description={description}>{header}</Header>}>
            <Container>
                {isFetching && (
                    <Box textAlign="center">
                        <Spinner size="large" />
                    </Box>
                )}
                {isError && (
                    <Alert type="error">Error loading dashboard. Please try again later.</Alert>
                )}
                <div id={DASHBOARD_CONTAINER_ID} />
            </Container>
        </ContentLayout>
    );
}